<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="f-grid adjust-subtitle-1">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">THÔNG TIN CHUNG</span>
            </div>
          </div>
        </div>

        <div class="f-grid adjust-border"> <!--Thong tin chung-->
          <div class="f-grid-col"> <!--1 collumn-->
            <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
              <label :class="{'txt-right' : true, 'required' : is_required}">Công ty</label>
              <DropdownScrollable cusClass="m-0 cs-width" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
              <input class="input-group input_tmp_validator" id="company" />
            </div>
            <div class="mt-2">
              <label class="txt-right required">Khóa đào tạo</label>
                <Textarea v-model="name" id="name" class="input-text-box cs-input" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)" rows="1" :autoResize="true" @keydown.enter.prevent/>
            </div>

            <div class="mt-2">
              <label class="txt-right">Ảnh</label>
              <input class="input_tmp_validator" id="images">
              <div class="cus-text">Kích thước đề xuất: 440x200px - Dung lượng tối đa: 50 MB</div>
              <div class="cus-text">Định dạng file:: JPG, JPEG, PNG, GIF (không phải ảnh động).</div>
              <input class="p-inputtext p-component cs-input" style="background-color: #EEEEEE;" accept="image/*" name="images[]" type="file" @change="onFileSelect"/>
              <div class="box-images mt-3 cs-input"  v-if="images && images.length">
                <div class="item-img" v-for="(item, index) in images" :key="index" >
                  <div class="button-clear" @click="onFileClear(index)"><img src="../../../assets/ic_clear.svg"/></div>
                  <img :src="item.objectURL" width="80" height="80"/>
                </div>
              </div>
            </div>
          </div>

          <div class="f-grid-col"> <!--2 collumn-->
            <!-- <div class="mt-2" v-if="mode=='add'">
              <label class="txt-right required">Loại khóa học</label>
              <div class="radio-group">
                <div style="display: flex;">
                  <input type="radio" name="courseType" value="online" v-model="type" @change="changeType"><span style="margin-left: 5px;"> Online</span>
                </div>
                <div style="display: flex;">
                  <input type="radio" name="courseType" value="offline" v-model="type" @change="changeType"><span style="margin-left: 5px;"> Offline</span>
                </div>
              </div>
            </div>

            <div class="mt-2" v-if="mode=='edit'">
              <label class="txt-right required">Loại khóa học</label>
              <InputText class="disable_type" :value="type_show" id="type_edit" readonly></InputText>
            </div> -->

            <div class="mt-2">
              <label class="txt-right required">Kết quả khóa học có hiệu lực trong</label>
              <div class="p-inputgroup">
                <InputText
                  v-model="expired_time"
                  id="expired_time"
                  type="Number"
                  class="text-box input-text-box"
                  placeholder="Nhập"
                  @input="allowOnlyNumbers('expired_time')"
                />
                <span class="p-inputgroup-addon">
                  tháng   
                </span>
              </div>
            </div>

            <!-- <div class="mt-2" v-if="type == 'online'">
              <label class="txt-right required">Thời lượng khóa học tối đa</label>
              <div class="p-inputgroup">
                <InputText
                  v-model="study_time"
                  id="study_time"
                  type="Number"
                  class="text-box input-text-box"
                  placeholder="Nhập"
                  @input="allowOnlyNumbers('study_time')"
                />
                <span class="p-inputgroup-addon">
                  tháng
                </span>
              </div>
            </div> -->
          </div>
        </div>

        <div class="f-grid adjust-subtitle-2">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">MÔ TẢ KHÓA HỌC</span>
            </div>
          </div>
        </div>

        <div class="adjust-border">
          <div class="mt-2 risk-topic-description">
            <label class="txt-right">Risk topic</label>
            <Textarea
              d="risk_topic_add"
              v-model="risk_topic"
              :autoResize="true"
              rows="2"
              maxlength="2000"
              class="input-text-box"
              placeholder="Nhập (tối đa 2,000 ký tự)"
            />
            <input class="input_tmp_validator" id="risk_topic" />
          </div>

          <div class="mt-2 risk-topic-description">
            <label class="txt-right required">Mô tả</label>
            <CKditorCore v-model="description" />
            <input class="input-group input_tmp_validator" id="description" />
          </div>
        </div>

        <div class="f-grid adjust-border">
          <div class="f-grid-col">
            <div class="mt-2">
              <Checkbox v-model="active" :binary="true" /><span>Hiển thị</span>
            </div>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>


    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
import CKditorCore from '@/views/admin/CkditorCoreCourse.vue'; // Import the CKditorCore component

export default {
  components:{
    DropdownScrollable,
    CKditorCore // Register the CKditorCore component
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      is_required: true,
      company: {},
      filters: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      name: "",
      images: [],
      imagesDeletes : [],
      maxFiles: 1,
      maxFileSize: 10485760*5,//1024*1024*50 = 50MB
      type: "offline",
      expired_time: null,
      study_time: null,
      risk_topic : "",
      active: true,
      description: '', // This will hold the content
      //type_show: '',
    }
  },
  async mounted() {
    await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.company = this.model.company;
      this.active = this.model.active;
      this.name = this.model.name;
      this.expired_time = this.model.expired_time;
      this.study_time = this.model.study_time;
      this.risk_topic = this.model.risk_topic;
      this.description = this.model.description;
      this.type = this.model.type;
      if (this.type == "online") {
        this.type_show = "Online";
      } else {
        this.type_show = "Offline";
      }
      if (!this.$commonFuction.isEmpty(this.model.list_files) && this.model.list_files.length > 0) {
        let url = this.model.list_files[0].file.url
        let split = url.split('/')
        let fileName = split[split.length - 1]
        let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.images.push(obj);
      }
    } else {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
      }
    } 
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        console.log("watch company_id", this.company);
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
        console.log("watch store company_id", this.company);
      }
    },
    async "company"() {
      if(this.mode == 'add'){
        // await this.clearChangeCompany();
      }
      if (this.mode == "edit" && this.loadKey == 0) {
        this.loadKey++;
      }
      
    },

  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    allowOnlyNumbers(field) {
      // Only allow positive integers
      const value = this[field];
      const numericValue = value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters

      // Ensure the value does not start with '0' unless it's the only character
      if (numericValue.length > 1 && numericValue.startsWith('0')) {
        this[field] = numericValue.substring(1);
      } else {
        this[field] = numericValue;
      }
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Vui lòng chọn công ty!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let name_add = document.getElementById("name");
      if (this.name == undefined || this.name == null || this.name == "") {
        name_add.setCustomValidity("Vui lòng nhập tên khoá đào tạo!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên khóa đào tạo không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }

      let expired_time_add = document.getElementById("expired_time");
      if (this.expired_time == undefined || this.expired_time == null || this.expired_time == "") {
        expired_time_add.setCustomValidity("Vui lòng nhập thời gian hiệu lực của khoá học!");
      } else if (this.expired_time <= 0) {
        expired_time_add.setCustomValidity("Thời gian hiệu lực phải lớn hơn 0!");
      } else {
        expired_time_add.setCustomValidity("");
      }

      if (this.type == "online") {
        let study_time_add = document.getElementById("study_time");
        if (this.study_time == undefined || this.study_time == null || this.study_time == "") {
          study_time_add.setCustomValidity("Vui lòng nhập thời gian thời lượng khoá học tối đa!");
        } else if (this.study_time <= 0) {
          study_time_add.setCustomValidity("Thời lượng khóa học tối đa phải lớn hơn 0!");
        } else {
          study_time_add.setCustomValidity("");
        }
      }

      let description_add = document.getElementById("description");
      if (this.description == undefined || this.description == null || this.description == "") {
        description_add.setCustomValidity("Vui lòng nhập mô tả khoá học!");
      } else {
        description_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }

      if (Object.keys(this.validationErrors).length > 0) {
        alert(Object.values(this.validationErrors).join("\n"));
        return true;
      }

    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        active: this.active,
        company: this.company,
        type: this.type,
        expired_time: this.expired_time,
        study_time: this.study_time,
        risk_topic: this.risk_topic,
        description: this.description,
        images: this.images,
      };
      console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 1) {
          alert("Chỉ được upload tối đa 1 ảnh");
          return;
        }
        let acceptTags = ["jpeg","jpg","gif","png","JPEG","JPG","PNG","GIF"];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Vui lòng upload file có định dạng là: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 50MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
    // async clearChangeCompany(){
    //   this.factory_users_obj ={
    //     offset: 0,
    //     filters: {},
    //     limit: 20,
    //     items: [],
    //     total: 0,
    //     loading: false
    //   }
    //   this.factory_users = []
    // },
    changeType() {
      if (this.type === 'online') {
        this.study_time = null; // Reset the max_time when switching to online
      }
    },
    updateDescription(newDescription) {
      this.description = newDescription[0];
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 6px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel-2 {
  color : #333333;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.radio-group {
  display: flex; /* Sử dụng flexbox để đặt chúng cùng hàng */
  gap: 40px; /* Khoảng cách giữa các radio button */
}
.adjust-subtitle-1 {
  margin: 10px 10px 0px 10px;
}
.adjust-subtitle-2 {
  margin: 20px 10px 0px 10px;
}
.adjust-border {
  margin: 10px 10px 0px 10px;
}
.risk-topic-description {
  margin: 0px 10px 0px 10px;
}
#name {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  overflow: hidden; /* Hide scroll bar */
  resize: none; /* Prevent manual resizing */
}
.disable_type {
  background-color: rgba(239, 239, 239, 0.3);
  color: #555;
}
</style>
